import { ActionListItem, GhostIconButton, Text } from "@certn/cascadia-react";
import { StepType } from "@certn/cascadia-react/components/stepper/ActivityStepper";
import { ProgressStepper } from "@certn/cascadia-react/components/stepper/ProgressStepper";
import { css } from "@emotion/css";
import React, { useState } from "react";
import { Trans, useTranslation } from "react-i18next";

import {
  CheckStatusType,
  CheckStatus,
} from "../../../components/check-status/CheckStatus";

type BaseCardProps = {
  title: string;
  type: CheckStatusType;
  tagText: string;
  statusText?: string | React.JSX.Element;
  progressSteps?: StepType[];
  variant?: "default" | "historyCard";
  shortID?: string;
};

export function BaseCard({
  title,
  type,
  tagText,
  statusText,
  progressSteps,
  variant = "default",
  shortID,
}: BaseCardProps) {
  const { t } = useTranslation();
  const [showProgress, setShowProgress] = useState(false);

  return (
    <ActionListItem
      title={title}
      tag={
        // title is above children but below tag/trailling, this component requires a margin
        <div
          className={css({ marginBottom: "var(--space-3)" })}
          data-testid="history-card-status"
        >
          <CheckStatus hasGrayBackground type={type}>
            {tagText}
          </CheckStatus>
        </div>
      }
      trailing={
        progressSteps && (
          <GhostIconButton
            testID={
              showProgress
                ? "history-card-show-less-button"
                : "history-card-show-more-button"
            }
            color="icon-base"
            icon={showProgress ? "expand_less" : "expand_more"}
            onPress={() => setShowProgress((value) => !value)}
            size="small"
            aria-label={showProgress ? t("Show Less") : t("Show More")}
            aria-expanded={showProgress}
          />
        )
      }
    >
      <Text testID="history-card-card-type">
        <Trans>Background check application</Trans>
      </Text>
      {statusText && <Text>{statusText}</Text>}
      {variant === "historyCard" && (
        <Text
          color="text-weak"
          style="form/body-secondary"
          testID="history-card-case-id"
        >{`${t("Case ID")}: ${shortID}`}</Text>
      )}
      {showProgress && (
        <div
          style={{ marginTop: "var(--space-4)" }}
          data-testid="progress-stepper"
        >
          <ProgressStepper steps={progressSteps ?? []} />
        </div>
      )}
    </ActionListItem>
  );
}
